loadjs.ready(['jquery', 'core'], function() {
    $body.on('click', '.loyalty-action', function() {
        var action = $(this).data('action')

        preloader(1);
        $.ajax({
            url: routes.checkout.loyalty.replace('_token_', token),
            type: action === 'apply' ? 'POST' : 'DELETE',
            data: {},
            success: function(response) {
                if (response.success) {
                    $body.trigger(action === 'apply' ? 'loyalty:added' : 'loyalty:removed')
                    return;
                }

                if (response.error) {
                    preloader(0)
                    showError(Array.isArray(response.error.message) ? response.error.message.join('\n') : response.error.message);
                }

            }
        });
        return false;
    })
})